'use client';

import { ThemeToggle } from '@/components/common/ThemeToggle';
import { Login } from '@/components/features/core/auth';
import ROUTES from '@/lib/constants/routeConfig';
import { useAuth } from '@/lib/hooks/useAuth';
import { useChangeLocale, useCurrentLocale } from '@/locales/client';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

export default function LoginPage() {
  const router = useRouter();
  const { status } = useAuth();
  const currentLocale = useCurrentLocale();
  const changeLocale = useChangeLocale();

  useEffect(() => {
    if (status === 'authenticated') {
      router.push(ROUTES.HOME);
    }
  }, [status, router]);

  return (
    <div className='bg-[#F9FAFB] dark:bg-background'>
      <div className='relative mx-auto max-w-[1200px]'>
        <div className='absolute right-4 top-4 flex items-center space-x-2'>
          <ThemeToggle />

          <div className='flex overflow-hidden rounded-md border border-[#E5E7EB] dark:border-gray-700'>
            <button
              onClick={() => changeLocale('en')}
              className={`px-3 py-1.5 text-sm font-medium transition-colors ${
                currentLocale === 'en'
                  ? 'bg-[#9147ff] bg-opacity-20 text-[#9147ff] dark:bg-purple-900/30 dark:text-purple-400'
                  : 'text-foreground hover:bg-gray-100 dark:hover:bg-gray-800'
              }`}
            >
              EN
            </button>
            <button
              onClick={() => changeLocale('fr')}
              className={`px-3 py-1.5 text-sm font-medium transition-colors ${
                currentLocale === 'fr'
                  ? 'bg-[#9147ff] bg-opacity-20 text-[#9147ff] dark:bg-purple-900/30 dark:text-purple-400'
                  : 'text-foreground hover:bg-gray-100 dark:hover:bg-gray-800'
              }`}
            >
              FR
            </button>
          </div>
        </div>
      </div>

      <div className='mx-auto grid min-h-dvh max-w-[1200px] grid-cols-1 gap-8 px-4 py-2 lg:grid-cols-2'>
        <div className='flex h-full items-center justify-center pt-4 sm:pt-0'>
          <Login />
        </div>
        <div className='hidden h-full items-center justify-center lg:flex'>
          <Image
            src={`https://s3.ca-central-1.amazonaws.com/assets.jaqln.ai/login-banner-${currentLocale}.png`}
            alt='Login Background'
            width={616}
            height={816}
            className='max-h-[calc(100vh-10rem)] rounded-lg border border-[#E5E7EB] object-cover dark:border-gray-700 dark:brightness-[0.85]'
            priority
          />
        </div>
      </div>
    </div>
  );
}
